// Preserve the pre-wizard registration/CV rule independently of UI language.
// Only use for first/last names, never passwords, email, IDs or free-text fields.
export const upperCareerName=value=>String(value??'').toLocaleUpperCase('tr-TR');
